<div *ngIf="!isEdited" class="cell-view">
  <div class="inner-view flex align-items-center">
    <div
      style="height: 1.5rem; width: 1.5rem; margin-right: 0.5rem"
      [style.background-color]="rowData[fieldName]"
    ></div>
    {{ rowData[fieldName] }}
  </div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="ColorCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="ColorCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="2 * minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <div class="flex">
    <p-colorPicker
      [(ngModel)]="rowData[fieldName]"
      jmlStopClickPropagation
      jmlLibOnEscape
      (onEscape)="abortCellEdit($event)"
      appendTo="body"
    ></p-colorPicker>
    <input
      pInputText
      #colorInput
      type="text"
      pattern="^#([a-fA-F0-9]{6})$"
      [(ngModel)]="rowData[fieldName]"
      style="width: calc(100% - 30px); border-radius: 0"
      (click)="$event.stopPropagation()"
      (keyup.enter)="onKeyupEnter(colorInput.validity.valid)"
      (keyup.esc)="abortCellEdit($event)"
      jmlClickOutside
      (clickOutside)="abortCellEdit($event)"
      jmlAutoFocus
    />
    <button
      pButton
      type="button"
      [id]="fieldName + '§' + rowData['id']"
      icon="pi pi-check"
      style="border-top-left-radius: 0; border-bottom-left-radius: 0"
      [disabled]="!colorInput.validity.valid"
      data-cy="ColorCell_Button_completeEdit"
      (click)="isEdited = false; completeCellEdit.emit({ data: rowData, field: fieldName })"
    ></button>
  </div>
</ng-template>
